import classNames from 'classnames'
import { useRef } from 'react'
import { useRouter } from 'next/router'
import styles from './index.module.scss'
import { RudderEvent } from 'constants/rudderEvents'
import useOutsideOnClick from 'hooks/useOutsideOnClick'
import useBreakpoint from 'hooks/useBreakPoint'
import {
  ProviderFilterTypes,
  ProviderHeaderFilterTypes,
} from 'dataSource/ProviderSearch'
import logEvent from 'utils/logEvent'

type HeaderFilterButtonProps = {
  showButton?: boolean
  showDropdown: boolean
  setShowDropdown: (showDropdown: boolean) => void
  filterType: ProviderFilterTypes | ProviderHeaderFilterTypes
  containerClassName?: string
  buttonClassName?: string[]
  onClick?: () => void
  text?: string
  title: string
  placeHolder: string
  mobilePlaceHolder: string
  type: string
}

const HeaderFilterButton: React.FC<HeaderFilterButtonProps> = ({
  showButton = true,
  showDropdown,
  setShowDropdown,
  containerClassName,
  buttonClassName,
  children,
  text,
  title,
  placeHolder = '',
  mobilePlaceHolder = '',
  type,
}) => {
  const router = useRouter()
  const containerRef = useRef<HTMLDivElement>(null)
  const { isMobileScreen, isLargeSize } = useBreakpoint()

  useOutsideOnClick({
    containerRef,
    callback: () => {
      if (showDropdown) {
        setShowDropdown(false)
      }
    },
  })

  const handleClick = () => {
    setShowDropdown(true)
    const rudderStackObject = {
      event_action: `click ${type}`,
      location_city: router.query.city,
      location_state: router.query.state,
    }

    if (router.query.specialty) {
      rudderStackObject['specialty'] = router.query.specialty
    }

    logEvent(RudderEvent.SE_FRIENDLY_SEARCH_CLICKED, rudderStackObject)
  }

  const showMobileView = isMobileScreen || isLargeSize

  return (
    <div
      ref={containerRef}
      className={classNames(
        'position-relative d-flex align-self-stretch',
        containerClassName
      )}
    >
      {showButton && (
        <button
          onClick={handleClick}
          className={classNames(
            buttonClassName[0],
            styles.selectable_header_button,
            `d-flex align-items-center flex-grow-1 align-self-stretch ${buttonClassName[1]}`
          )}
        >
          <div className="flex-fill">
            {showMobileView ? (
              <div
                className={classNames('d-flex fs-16 justify-content-center', {
                  'text-slate-gray': !text, // Placeholder
                  [styles.filter_text]: !!text,
                })}
              >
                <div className={styles.selectable_button_text}>
                  {text || mobilePlaceHolder}
                </div>
              </div>
            ) : (
              <>
                {text ? (
                  <div className="d-flex">
                    <div
                      data-has-value={!!text}
                      className={styles.new_selectable_button_text}
                    >
                      {text || placeHolder}
                    </div>
                    {/* filterArrowDown */}
                  </div>
                ) : (
                  <div className={styles.filter_text}>{title}</div>
                )}
              </>
            )}
          </div>
        </button>
      )}
      {showDropdown && children}
    </div>
  )
}

export default HeaderFilterButton
